/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * UC Monitoring API
 * UC Monitoring: Call Quality + Room Utilization
 * OpenAPI spec version: 1.0
 */

/**
 * Attendee response to the invite
 */
export type CalendarResponseStatus = (typeof CalendarResponseStatus)[keyof typeof CalendarResponseStatus];

export const CalendarResponseStatus = {
  NONE: 'none',
  ORGANIZER: 'organizer',
  TENTATIVELYACCEPTED: 'tentativelyAccepted',
  ACCEPTED: 'accepted',
  DECLINED: 'declined',
  NOTRESPONDED: 'notResponded',
} as const;
